import { useForm } from '@mantine/form';
import classes from './Auth.module.css';
import { Button, Group, TextInput } from '@mantine/core';
import { useAuth } from '../../hooks/useAuth.tsx';
import { serverAccessor } from '../../accessors/serverAccessor.ts';
import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Seo from '../../components/Seo.tsx';

function Auth() {
    const auth = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            password: '',
        },
    });

    useEffect(() => {
        if (auth.isAuthenticated) {
            navigate('/admin');
        }
    }, [auth.isAuthenticated, navigate]);

    const seoTitle = t('seo.loginTitle');
    const seoDescription = t('seo.loginDescription');

    const handleSubmit = async (values: typeof form.values) => {
        const res = await serverAccessor.login(values.password);
        auth.login(res.accessToken);
        navigate('/admin');
    };

    return (
        <>
            <Seo title={seoTitle} description={seoDescription} canonicalPath="/login" noindex />
            <div className={classes.auth}>
                <div className={classes.authInner} >
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <TextInput
                            classNames={{ input: classes.input, label: classes.label }}
                            withAsterisk
                            label="Password"
                            placeholder="Your password"
                            type='password'
                            key={form.key('password')}
                            {...form.getInputProps('password')}
                        />

                        <Group justify="flex-end" mt="md" w="100%">
                            <Button type="submit" color='#0F4735' className={classes.submit}>Submit</Button>
                        </Group>
                    </form>
                </div>
            </div>
        </>
    );
}

export default Auth;
